import React, { useEffect, useState } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Cell } from "recharts";
import { Loader2 } from "lucide-react";
import api, { formatMoney, formatNumber } from "../lib/api";
import DrillDown from "./DrillDown";
import { AvisoStockAntiguo } from "./AvisoStockAntiguo";

export function EntradasStockChart({ lab, segment, studyId }) {
  const [d, setD] = useState(null);
  const [drill, setDrill] = useState(null);
  const abrir = (r) => {
    if (!r || r.key === "sin" || !r.refs) return;
    const [desde, hasta] = r.key.length === 4 ? [`${r.key}-01-01`, `${r.key}-12-31`]
      : [`${r.key}-01`, `${r.key}-${String(new Date(+r.key.slice(0, 4), +r.key.slice(5, 7), 0).getDate()).padStart(2, "0")}`];
    setDrill({
      title: `${lab} · stock entrado en ${r.label}`,
      subtitle: `Productos con stock cuya última entrada fue en ${r.label} · ${formatMoney(r.stock)} a PVP`,
      filters: { laboratorio: lab, segment, entrada_from: desde, entrada_to: hasta, con_stock: true },
    });
  };
  useEffect(() => {
    setD(null);
    api.get("/labs-resumen/entradas", { params: { laboratorio: lab, segment, study_id: studyId } })
      .then((r) => setD(r.data)).catch(() => setD({ rows: [] }));
  }, [lab, segment, studyId]);
  if (!d) return <div className="card p-6 mb-6 text-slate-500 flex items-center gap-2"><Loader2 size={14} className="animate-spin" /> Cargando entradas de stock…</div>;
  if (!d.rows.length) return null;
  const viejo = d.rows.filter((r) => r.key.length === 4 || r.key === "sin").reduce((t, r) => t + r.stock, 0);
  return (
    <>
    <AvisoStockAntiguo a={d.antiguo} lab={lab} />
    <div className="card p-6 mb-6" data-testid="lab-entradas-chart">
      <div className="flex items-start justify-between gap-3 flex-wrap mb-2">
        <div>
          <h3 className="font-display text-lg font-bold">¿Cuándo entró el stock que tienes?</h3>
          <p className="text-xs text-slate-500">Stock actual (a PVP) según la fecha de su última entrada: por meses de {d.year} y por años anteriores. Pulsa una barra para ver sus productos.</p>
        </div>
        <div className="text-right">
          <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">Entrado antes de {d.year}</div>
          <div className="font-display text-xl font-extrabold text-red-600" data-testid="lab-entradas-antiguo">
            {formatMoney(viejo)} <span className="text-sm text-slate-500">({d.total ? ((100 * viejo) / d.total).toFixed(1).replace(".", ",") : 0} %)</span>
          </div>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={d.rows}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
          <XAxis dataKey="label" tick={{ fontSize: 11 }} />
          <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => formatMoney(v)} width={80} />
          <Tooltip formatter={(v, n, it) => [`${formatMoney(v)} · ${formatNumber(it.payload.refs)} refs · ${formatNumber(it.payload.uds)} uds · ${String(it.payload.pct).replace(".", ",")} %`, "Stock"]}
                   contentStyle={{ borderRadius: 6, fontSize: 12 }} />
          <Bar dataKey="stock" name="Stock" radius={[4, 4, 0, 0]} cursor="pointer" onClick={(bar) => abrir(bar?.payload)}>
            {d.rows.map((r) => <Cell key={r.key} fill={r.key.length === 4 || r.key === "sin" ? "#991b1b" : "#dc2626"} data-testid={`lab-entradas-bar-${r.key}`} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <DrillDown open={!!drill} onClose={() => setDrill(null)} studyId={studyId || d.study_id} title={drill?.title} subtitle={drill?.subtitle} filters={drill?.filters || {}} />
    </div>
    </>
  );
}
